import {
  createFrontendModule,
  ApiBlueprint,
} from '@backstage/frontend-plugin-api';
import { convertLegacyEntityCardExtension } from '@backstage/plugin-catalog-react/alpha';
import {
  createApiFactory,
  discoveryApiRef,
  configApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import {
  EntityJiraQueryCard,
  hasJiraQuery,
  jiraApiRef,
  JiraAPI,
} from '@roadiehq/backstage-plugin-jira';

// `@roadiehq/backstage-plugin-jira` ships only legacy (old-frontend-system)
// pieces (no `/alpha`), so two things are bridged into the new frontend system:
//
//  1. The Jira API implementation (jiraApiRef → JiraAPI), re-registered via
//     ApiBlueprint from the plugin's own createApiFactory. Without it the card
//     throws "No implementation available for apiRef{plugin.jira.service}".
//
//  2. The entity card. We deliberately use EntityJiraQueryCard (a JQL-driven
//     issues table) and NOT EntityJiraOverviewCard: the overview card always
//     renders an activity stream that hits Jira's legacy `/activity` gadget
//     endpoint, which is unavailable via the scoped-token api.atlassian.com
//     gateway (HTTP 401) and cannot be disabled — it takes the whole card down.
//     The query card only calls `/rest/api/3/search/jql`, which works with the
//     scoped token.
//
// A component opts in with the `jira/all-issues-jql` annotation, e.g.:
//   metadata.annotations:
//     jira/all-issues-jql: project = PLATFORM ORDER BY updated DESC
const jiraApi = ApiBlueprint.make({
  name: 'jira',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: jiraApiRef,
        deps: {
          discoveryApi: discoveryApiRef,
          configApi: configApiRef,
          fetchApi: fetchApiRef,
        },
        factory: ({ discoveryApi, configApi, fetchApi }) =>
          new JiraAPI({ discoveryApi, configApi, fetchApi }),
      }),
    ),
});

export const jiraModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    jiraApi,
    convertLegacyEntityCardExtension(EntityJiraQueryCard, {
      name: 'jira-issues',
      filter: hasJiraQuery,
    }),
  ],
});
